import React from 'react';
import './App.css';
import './ThankYou.css';
import {Tooltip} from '@material-ui/core';
function ThankYou() {
    return (
        <div className="wrapper" id="full">
            <div className="workExperience" >
            <h1 className="sectionHeading" >thank you</h1>
            <h2>Through my journey in tech, I've come across some amazing people who have helped and guided me in so many ways:</h2>

            <div className="peopleToThank">

            <Tooltip title="Thanks for encouraging me to aim high and believe in myself. You are the most inspirational person I've met."> 
            <h3 className="personName">Bala Sahitya Vadlamani</h3>
            </Tooltip>

            <Tooltip title="Thanks for inspiring this website and giving amazing advice on everything from my career to my education"> 
            <h3 className="personName">Prarthana Sannamani</h3>
            </Tooltip>

            <Tooltip title="Thanks for spending countless hours helping debug Pop and broadening my understanding of React/development in general.">
            <h3 className="personName">Nuh Mohamud</h3>
            </Tooltip>

            <Tooltip title="Thanks for being a super supportive coach and providing invaluable insights from your perspective as a PM">
            <h3 className="personName">Shuyin Zhao</h3>
            </Tooltip>

            <Tooltip title="Thanks for being a supportive professor and inspiring my love for Computer Science. Your passion for the subject is contagious!">
            <h3 className="personName">Scott Edwards</h3>
            </Tooltip>

            <Tooltip title="Thanks for supporting the BBG club on campus and being a great mentor!">
            <h3 className="personName">Kara Pham</h3>
            </Tooltip>

            <Tooltip title="Thanks for cultivating my interest in Data Science and for all your continued support.">
            <h3 className="personName">Scott Malloy</h3>
            </Tooltip>

            <Tooltip title="Thanks for being my BBG mentor and giving such great advice">
            <h3 className="personName">Kristine Pearce</h3>
            </Tooltip>

            <Tooltip title="Thanks for changing the way I think about building a product and inspiring me to chase my tech goals">
            <h3 className="personName">Poonam Hattangandy</h3>
            </Tooltip>

            <Tooltip title="Thanks for your invaluable life/career advice and thoughtful, constructive feedback">
            <h3 className="personName">Ken Long</h3>
            </Tooltip>

            <Tooltip title="Thanks for always giving great advice and making time for me even with your busy schedule">
            <h3 className="personName">Jessie Segal</h3>
            </Tooltip>


            <Tooltip title="Thanks for being a wonderful and accessible instructor who was always willing to help">
            <h3 className="personName">Sara Farag</h3>
            </Tooltip>
            <Tooltip title="Thanks all your NASA internship advice. I got my first internship because of you!">
            <h3 className="personName">Shalin Brahmbhatt</h3>
            </Tooltip>


            <Tooltip title="Thanks for all the advice about the TNT program and for looking over my application.">
            <h3 className="personName">Ibrahim Yusuf</h3>
            </Tooltip>

            <Tooltip title="Thanks for helping me with EVERYTHING from college apps to job applications">
            <h3 className="personName">Hafsah Lakhany</h3>
            </Tooltip>

            </div>
            </div>
           
        </div>
    );

}

export default ThankYou;